module.exports = __webpack_public_path__ + "static/media/logout-off.97ca02f0.svg";